"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuditGet = useAuditGet;
const index_1 = require("../../ui/hooks/index");
const swr_1 = __importDefault(require("swr"));
/**
 * Hook to fetch audit information by ID using SWR for data fetching and caching.
 *
 * This hook utilizes the `useAuditClient` to create an audit client and fetches audit data by ID
 * using the `useSWR` hook. It optionally accepts a base URL for the audit service, a token provider
 * for authentication, and additional configuration for SWR.
 *
 * @param id - The ID of the audit to fetch.
 * @param baseUrl - optional base URL
 * @param tokenProvider - optional token provider
 * @param config - custom SWR configuration object
 * @returns {SWRResponse<GetAuditResponse, unknown>} The SWR response object containing the audit data, loading state, and error information.
 */
function useAuditGet(id, baseUrl, tokenProvider, config) {
    const auditClient = (0, index_1.useAuditClient)(baseUrl, tokenProvider);
    return (0, swr_1.default)([`/platform/audit/getById`, id], async ([, id]) => {
        return await auditClient.get({ id: id });
    }, config ?? {
        revalidateOnFocus: false,
    });
}
